/**
 * Doubloon: Protection Plan cart upsell
 * Handles AJAX add of the Protection Plan from the cart drawer,
 * then refreshes the cart sections so the upsell state updates.
 */
(function () {
  const SELECTORS = {
    upsell: '.doubloon-cart-upsell',
    addButton: '[data-add-protection]',
  };

  function addProtection(e) {
    const button = e.currentTarget;
    const upsell = button.closest(SELECTORS.upsell);
    const variantId = upsell?.dataset.protectionVariant;
    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Adding\u2026';

    fetch(window.Shopify?.routes?.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return refreshCart();
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = 'Add Protection';
      });
  }

  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then((res) => res.json())
      .then((sections) => {
        const drawerHTML = sections['cart-drawer'];
        if (drawerHTML) {
          const drawerInner = document.querySelector('.drawer__inner');
          if (drawerInner) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(drawerHTML, 'text/html');
            const newInner = doc.querySelector('.drawer__inner');
            if (newInner) drawerInner.innerHTML = newInner.innerHTML;
          }
        }

        const bubbleHTML = sections['cart-icon-bubble'];
        if (bubbleHTML) {
          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(bubbleHTML, 'text/html');
            const newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }

        bindListeners();
      });
  }

  function bindListeners() {
    document.querySelectorAll(SELECTORS.addButton).forEach((btn) => {
      btn.removeEventListener('click', addProtection);
      btn.addEventListener('click', addProtection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindListeners);
  } else {
    bindListeners();
  }

  // Re-bind after Shopify's cart drawer re-renders
  const observer = new MutationObserver(() => bindListeners());
  const target = document.getElementById('CartDrawer');
  if (target) observer.observe(target, { childList: true, subtree: true });
})();
